<template>
  <div class="tooltip">
      <div class="tooltip__head">
        <span>{{ seat.seat_number }} {{ formatPrice(seatPrice) }} </span>
      </div>
        <p v-if="seatDescription">{{ seatDescription }}</p>
    <div class="tooltip__pointer"></div>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from 'vue'
  import { CarriageSeat } from '@/types/seatTypes'
  import { formatPrice } from '@/utils/formatters'

  export default defineComponent({
    name: 'Tooltip',
    props: {
      seat: {
        type: Object as PropType<CarriageSeat>,
        required: true,
      },
      seatPrice: {
        type: Number,
        required: true,
      },
      seatDescription: {
        type: String,
        required: false,
        default: '',
      },
    },
    setup(props) {
      return {
        formatPrice,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .tooltip {
    visibility: hidden;
    position: absolute;
    background-color: $clr-primary;
    color: $clr-white;
    padding: 10px;
    border-radius: $border-radius;
    pointer-events: none;
    z-index: 25;
    top: -75px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    box-shadow: $box-shadow-card;

    &__head {
      @include body-large;
    }

    &__content {
      @include body-large;
    }

    &__description {
      @include body-small;
      color: $clr-text;
      margin-top: 4px;
    }

    &__pointer {
      position: absolute;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid $clr-primary;
      top: 100%;
      left: 50%;
      z-index: 15;
      transform: translateX(-50%);
    }
  }
</style>
